import Table from "@tiptap/extension-table";

/**
 * Table node with a markdown serializer that always emits a proper GFM table.
 *
 * tiptap-markdown's built-in table serializer bails out to the literal string
 * "[table]" whenever the first row isn't made entirely of <th> (tableHeader)
 * cells. A table pasted from outside (webpage, Excel, Word) arrives as plain
 * <td> cells with no header row, so it always hit that fallback and saved as
 * "[table]" instead of the real content.
 *
 * GFM tables are required to have a header row, so we treat the first row as the
 * header no matter what its cells are and serialize every table to markdown.
 * getMarkdownSpec() merges this storage.markdown over the library default (by
 * node name), so defining it here wins.
 */
export default Table.extend({
  addStorage() {
    return {
      markdown: {
        serialize(state, node) {
          state.inTable = true;
          node.forEach((row, _rowOffset, rowIndex) => {
            state.write("| ");
            row.forEach((cell, _cellOffset, colIndex) => {
              if (colIndex) state.write(" | ");
              // A cell can hold several block nodes; GFM cells are single-line,
              // so collapse them onto one line separated by a space.
              cell.forEach((block, _blockOffset, blockIndex) => {
                if (blockIndex) state.write(" ");
                if (block.textContent.trim()) state.renderInline(block);
              });
            });
            state.write(" |");
            state.ensureNewLine();
            if (rowIndex === 0) {
              const delimiter = Array.from({length: row.childCount})
                  .map(() => "---")
                  .join(" | ");
              state.write(`| ${delimiter} |`);
              state.ensureNewLine();
            }
          });
          state.closeBlock(node);
          state.inTable = false;
        },
        parse: {
          // parsing stays with markdown-it (tiptap-markdown default)
        },
      },
    };
  },
});
